/* eslint-disable no-unused-vars */
import React from 'react'
import { Col, Container, Row, Button } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { filterActionsByActionType, formatMiddleName, filterFinishedActionsByActionType, getTotalS2kScore, getFlareIndex, transformDate } from '../../../utils/helpers'
import Layout from '../../Layouts/Layout'
import { createAppointmentsRequest, createDocumentReference } from '../../../redux/actions/wrapup'
import {  buildPatientName } from '../../../utils/ehr-client'
import { useLocation, useParams } from 'react-router-dom'
import format from 'date-fns/format'
import ErrorBoundary from '../../ErrorBoundary'

const filteredActions = (actions) => actions.map((action) => {
  const splitOrder = action.action.description ? action.action.description.split(': ') : []
  return (
    <div key={action.actionId}>
      {splitOrder.length > 0 ? `${splitOrder[1]} ${splitOrder[2] ? ` : ${splitOrder[2]}` : ''}` : JSON.stringify(splitOrder)}
    </div>
  )
})

const Finish = () => {
  const location = useLocation()
  const { step } = useParams()

  const {
    createAppointment, 
    createDocument,
    patient,
    additionalNote, 
    rules, 
    encounter,
    ccpActions,
    lupusEncounter,
    s2k, 
    flare, 
    pga,
    assembledNote,
    subActions
  } = useSelector((state) => ({
    createAppointment: state.wrapup.createAppointment,
    createDocument: state.wrapup.createDocument,
    patient: state.patient.patient,
    additionalNote: state.ccp.additionalNote,
    encounter: state.patient.encounter,
    rules: state.ccp.rules,
    ccpActions: state.ccp.actions,
    lupusEncounter: state.patient.encounter,
    s2k: state.assessment.s2k,
    flare: state.assessment.flare,
    pga: state.assessment.pga,
    assembledNote: state.ccp.assembledNote,
    subActions: state.ccp.subActions
  }))

  const dispatch = useDispatch()

  // const retryPlaceOrders = () => {
  //   const allOrders = filterActionsByActionType(rules, ccpActions, 'Order')
  //   const orders = []
  //   allOrders.forEach(element => {
  //     if (element.checked) {
  //       orders.push(element)
  //     }
  //   })
  //   // dispatch()
  // }

  const retryAppointmentsRequest = () => {
    const scheduling = filterActionsByActionType(rules, ccpActions, subActions, 'Schedule')
    const schedule = []
    scheduling.forEach(element => {
      if (element.checked) {
        schedule.push(element)
      }
    })
    dispatch(createAppointmentsRequest(schedule))
  }

  const retryAssembledNote = () => {
    dispatch(createDocumentReference(assembledNote))
  }

  return (
    <Layout showNav={false} showFooter={false} showNavResult={step === 'done'}>
      <h2>Finished</h2>
      <Container fluid className='border'>
        {
          step === 'exit' && (
            <Row id='save-exit-row'>
              <Col xs={12} className='text-center mt-5'>
                <div id='save-exit'>
                 Your session for {buildPatientName(patient)}, MRN: {patient.mrn} has been saved.
                </div>
              </Col>
            </Row>
          )
        }
        {
          step === 'done' && (
            <Row>
              <Col xs={4}>
                <Container id='pp' fluid className='shadow-sm my-2 pb-2'>
                  <h3 className='h5'>Patient Profile</h3>
                  <p className='font-weight-bold'>
                    {patient && `${patient.firstName} ${formatMiddleName(patient.middleName)} ${patient.lastName}`}
                  </p>
                  <p>
                    MRN: {patient.mrn}
                  </p>
                  <p>
                    Encounter: {format(new Date(transformDate(encounter.date)), 'MM/dd/yyyy')}
                  </p>
                  <p>
                    Current SLEDAI-2k: {lupusEncounter.sledai ? lupusEncounter.sledai.score : getTotalS2kScore(s2k)}
                  </p>
                  <p>
                    Flare: {lupusEncounter.flare ? lupusEncounter.flare.score : getFlareIndex(flare)}
                  </p>
                  
                  <p>
                    {lupusEncounter.pga ? lupusEncounter.pga.value !== -1 ? `PGA: ${lupusEncounter.pga.value}` : pga !== -1 ? `PGA: ${pga}` : null : null }
                    
                  </p>
                </Container>
              </Col>
              <Col xs={4}>
                <Container id='order-status' fluid className='shadow-sm my-2 pb-2'>
                  <h3 className='h5 mb-1'>Orders</h3>
                  <ErrorBoundary
                    fallback={<p>We are running into issues displaying your orders.</p>}
                  >
                    <>
                      <p className='mb-2'>The following orders have been sent to Epic</p>
                      <div className='mb-1'>
                        {
                          lupusEncounter.status.status === 'FINISHED'
                            ? (
                              <>
                                {
                                  filterFinishedActionsByActionType(lupusEncounter.actions, 'Order').length === 0 && filterFinishedActionsByActionType(lupusEncounter.actions, 'Rx').length === 0
                                    ? 'No orders placed.'
                                    : (
                                      <div>
                                        {filteredActions(filterFinishedActionsByActionType(lupusEncounter.actions, 'Order'))}
                                        {filteredActions(filterFinishedActionsByActionType(lupusEncounter.actions, 'Rx'))}
                                      </div>
                                    )
                                }
                              </>
                            )
                            : (
                              <>
                                {
                                  location.state.ordersDone && (filterActionsByActionType(rules, ccpActions, subActions, 'Order').length > 0 || filterActionsByActionType(rules, ccpActions, subActions, 'Rx').length > 0) ? (
                                    <>
                                      {
                                        location.state.orders.reduce((acc, curr) => {
                                          if (curr) {
                                            if (curr.ordered) {
                                              if (curr.actionType !== 'Order Referral') {
                                                const splitOrder = curr.description ? curr.description.split(': ') : []
  
                                                return [...acc, 
                                                  <div key={curr.actionId}>
                                                    {splitOrder.length > 0 ? `${splitOrder[1]} ${splitOrder[2] ? ` : ${splitOrder[2]}` : ''}` : JSON.stringify(curr)}
                                                  </div>
                                                ]
                                              }
                                            }
                                          }
                                          return acc
                                        }, [])
                                      }
                                      {
                                        location.state.orders.reduce((acc, curr) => {
                                          if (curr) {
                                            if (!curr.ordered) {
                                              if (curr.actionType !== 'Order Referral') {
                                                const splitOrder = curr.description.split(': ')
  
                                                return [...acc, 
                                                  <div key={curr.actionId}>
                                                    {splitOrder[1]}{splitOrder[2] ? `: ${splitOrder[2]}` : ''} - <span className='font-italic red-font'>Organization unable to send this order</span>
                                                  </div>
                                                ]
                                              }
                                            }
                                          }

                                          return acc
                                        }, [])
                                      }
                                    </>
                                  ) : 'No Orders Placed.'
                                }
                              </>
                            )
                        }
                      </div>
                    </>
                  </ErrorBoundary>
                  <h3 className='h5 mb-1 mt-2'>Referrals</h3>
                  <ErrorBoundary
                    fallback={<p>We are running into issues displaying your orders.</p>}
                  >
                    <>
                      <div className='mb-1'>
                        {
                          lupusEncounter.status.status === 'FINISHED'
                            ? filterFinishedActionsByActionType(lupusEncounter.actions, 'Schedule').length > 0 || filterFinishedActionsByActionType(lupusEncounter.actions, 'Order Referral').length > 0
                              ? filteredActions(filterFinishedActionsByActionType(lupusEncounter.actions, 'Schedule')) || filteredActions(filterFinishedActionsByActionType(lupusEncounter.actions, 'Order Referral'))
                              : 'No referrals placed.'
                            : (
                              <>
                                {
                                  createAppointment.success && filterActionsByActionType(rules, ccpActions, subActions, 'Schedule').length > 0
                                    ? (
                                      <>
                                        {
                                          filterActionsByActionType(rules, ccpActions, subActions, 'Schedule').map((action) => (
                                            <div key={action.actionId}>
                                              {action.description.split(': ')[1]}
                                            </div>
                                          ))
                                        }
                                      </>
                                    )
                                    :  location.state.ordersDone && filterActionsByActionType(rules, ccpActions, subActions, 'Order Referral').length > 0 ? (
                                      <>
                                        {
                                          location.state.orders.reduce((acc, curr) => {
                                            if (curr) {
                                              if (curr.ordered) {
                                                if (curr.actionType === 'Order Referral') {
                                                  const splitOrder = curr.description ? curr.description.split(': ') : []
  
                                                  return [...acc, 
                                                    <div key={curr.actionId}>
                                                      {splitOrder.length > 0 ? `${splitOrder[1]} ${splitOrder[2] ? ` : ${splitOrder[2]}` : ''}` : JSON.stringify(curr)}
                                                    </div>
                                                  ]
                                                }
                                              }
                                            }

                                            return acc
                                          }, [])
                                        }
                                        {
                                          location.state.orders.reduce((acc, curr) => {
                                            if (curr) {
                                              if (!curr.ordered) {
                                                if (curr.actionType === 'Order Referral') {
                                                  const splitOrder = curr.description.split(': ')
  
                                                  return [...acc, 
                                                    <div key={curr.actionId}>
                                                      {splitOrder[1]}{splitOrder[2] ? `: ${splitOrder[2]}` : ''} - <span className='font-italic red-font'>Organization unable to send this order</span>
                                                    </div>
                                                  ]
                                                }
                                              }
                                            }
                                            return acc
                                          }, [])
                                        }
                                      </>
                                    ): 'No referrals placed.'
                                }
                                {
                                  createAppointment.error !== false && (
                                    <><div>Unable to send appointment requests to Epic.</div>
                                      <Button variant='outline-primary mr-1 btn-sm' onClick={retryAppointmentsRequest}>
                                    Retry
                                      </Button>
                                    </>
                                  )
                                }
                              </>
                            )
                        }
                      </div>
                    </>
                  </ErrorBoundary>
                  <h3 className='h5 mb-1 mt-2'>Patient Education</h3>
                  <div className='mb-1'>
                    {
                      lupusEncounter.status.status === 'FINISHED'
                        ? filterFinishedActionsByActionType(lupusEncounter.actions, 'Patient Education').length > 0
                          ? filteredActions(filterFinishedActionsByActionType(lupusEncounter.actions, 'Patient Education'))
                          : 'No Patient Education sent.'
                        : (
                          <>
                            {
                              filterActionsByActionType(rules, ccpActions, subActions, 'Patient Education').length > 0
                                ? filterActionsByActionType(rules, ccpActions, subActions, 'Patient Education').map((action) => (
                                  <div key={action.actionId}>
                                    {action.name}
                                  </div>
                                ))
                                : 'No Patient Education sent.'
                            }
                          </>
                        )
                    }
                  </div>
                </Container>
              </Col>
              <Col xs={4}>
                <Container id='note-status' fluid className='shadow-sm my-2 pb-2'>
                  <h3 className='h5'>Assembled Note</h3>
                  {
                    lupusEncounter.status.status === 'FINISHED'
                      ? (
                        <>
                          {
                            lupusEncounter.note && (
                              <>
                                <div style={{ whiteSpace: 'pre-wrap' }}>
                                  {lupusEncounter.note.assembled}
                                </div>
                                <div className='mt-3'>
                                  {lupusEncounter.note.additionalNote}
                                </div>
                              </>

                            )
                          }
                        </>
                      )
                      : (
                        <>
                          {
                            createDocument.success && (
                              <>
                                <b>Successfully sent Assembled Note.</b>
                                <div className='mb-3'>
                                  {createDocument.data.data}
                                </div>
                                <hr />
                                <div style={{ whiteSpace: 'pre-wrap' }}>
                                  {assembledNote}
                                </div>
                                <div className='mt-3'>
                                  {additionalNote}
                                </div>
                              </>
                            )
                          }
                          {
                            createDocument.error !== false && (
                              <><div>Unable to send Assembled Note to Epic.</div>
                                <Button variant='outline-primary mr-1 btn-sm' onClick={retryAssembledNote}>
                                  Retry
                                </Button>
                              </>
                            )
                          }
                        </>
                      )
                  }
                </Container>
              </Col>
            </Row>
          )
        }
      </Container>
    </Layout>
  )
}

export default Finish
